var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasketIcon = function SvgBasketIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#748DA9",
    d: "M11.805.865 14.48 5.5h2.852v1.667h-.972l-.631 7.57a.833.833 0 0 1-.83.763H3.1a.833.833 0 0 1-.83-.764l-.632-7.57H.667V5.5h2.851L6.195.865l1.443.834L5.443 5.5h7.113L10.362 1.7zm2.883 6.302H3.311l.555 6.667h10.266zM9.833 8.834v3.333H8.166V8.834zm-3.333 0v3.333H4.833V8.834zm6.666 0v3.333H11.5V8.834z"
  })));
};
export default SvgBasketIcon;